import {Layout, Menu, MenuProps} from 'antd';
import {Navigate, NavLink, Route, Routes, useLocation} from 'react-router-dom';
import {useAppSelector} from '../../../common/hooks';
import Catagories from './chargerCategory/ChargerCatagory';
import Chargers from './chargers/Chargers';
type MenuItem = Required<MenuProps>['items'][number];

const {Header, Content} = Layout;

const Main = () => {
  const userPermission = useAppSelector((state) => state.config.config.permissions);
  const items: MenuItem[] = [
    userPermission.show_charger
      ? {label: <NavLink to={'chargers'}>Chargers</NavLink>, key: 'chargers'}
      : null,
    userPermission.show_chargercategory
      ? {label: <NavLink to={'catagories'}>Catagories</NavLink>, key: 'catagories'}
      : null,
  ];

  return (
    <Layout style={{height: '100%', backgroundColor: '#fff'}}>
      <Header
        style={{
          backgroundColor: '#fff',
          alignItems: 'center',
          paddingInline: '00px',
          height: '48px',
          marginBottom: '10px',
          borderBottom: ' 1px solid #00000022',
        }}
      >
        <Menu
          mode='horizontal'
          theme='light'
          selectedKeys={[useLocation().pathname.split('/')[3]]}
          style={{
            backgroundColor: 'transparent',
            border: '0px',
            lineHeight: '40px',
          }}
          items={items}
        />
      </Header>
      <Content style={{padding: '0px 30px 0px'}}>
        {/* <h1>asdad</h1> */}
        <Routes>
          {userPermission.show_chargercategory && (
            <Route path='/catagories' element={<Catagories />} />
          )}
          <Route path='/' element={userPermission.show_charger && <Navigate to={'chargers'} />} />
          {userPermission.show_charger && <Route path='/chargers' element={<Chargers />} />}{' '}
          <Route path='/*' element={<Navigate to={'/404/'} />} />
        </Routes>
      </Content>
    </Layout>
  );
};

export default Main;
